import initialstate from '../initialstate';
import {SET_IS_MEDIA_PLAYING} from '../../actions/actiontypes';

export default function mediaPlayingReducer(state = initialstate.isMediaPlaying, action) {
	switch (action.type) {
		case SET_IS_MEDIA_PLAYING:
			return action.isMediaPlaying;

		default:
			return state;
	}
}
